<template>
  <section class="search-card" id="searchDiv" aria-label="Program arama">
    <form class="search-form" @submit.prevent="getInfo(this)">
      <div class="field field--type">
        <label class="field-label" id="label-program-type">Program Türü</label>
        <vue-select
          :options="[
            { code: 5863, label: 'Tezsiz Yüksek Lisans' },
            { code: 5369, label: 'Tezli Yüksek Lisans' },
            { code: 5371, label: 'Doktora' },
            { code: 5372, label: 'Lisans Dereceli Doktora' },
          ]"
          placeholder="Seçiniz"
          @update:modelValue="programTypeChanged($event)"
        ></vue-select>
      </div>

      <div class="field" v-if="!isNoThesisProgramTypeSelected">
        <label class="field-label" id="label-program"
          >Mezun Olduğunuz Program</label
        >
        <vue-select
          @search="onSearch"
          :options="options"
          label="adi"
          required
          @update:modelValue="programChanged($event)"
          placeholder="Aramak için yazmaya başlayın"
        >
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching && search.length > 2">
              “<em>{{ search }}</em
              >” ile eşleşen bir program bulunamadı.
            </template>
            <template v-else>En az 3 karakter yazın.</template>
          </template>
        </vue-select>
        <span class="field-hint"
          >Örn. “bilgisayar”, “işletme”, “moleküler biyoloji”…</span
        >
      </div>

      <div class="field field--submit" v-if="!isNoThesisProgramTypeSelected">
        <button type="submit" class="btn btn-primary btn-search">
          Programları Bul
        </button>
      </div>

      <p v-if="isNoThesisProgramTypeSelected" class="tezsiz-hint">
        Tezsiz yüksek lisans programları için bölüm seçimi gerekmez —
        başvurabileceğiniz programlar aşağıda listelenmiştir.
      </p>
    </form>

    <p v-if="isNewApplicationOpen === false" class="search-note">
      Yeni başvuru dönemi açıldığında haberdar olmak için
      <a data-toggle="modal" data-target="#newsletter">bültene kayıt olun</a>.
    </p>

    <div
      class="modal fade"
      id="newsletter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="newsletterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Kapat"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="newsletterTitle">Bültene Kayıt Ol</h4>
          </div>
          <div class="modal-body text-center">
            <p>
              Yeni ilanlar açıldığında haberdar olmak için bültenimize kayıt
              olabilirsiniz.
            </p>
            <div class="input-group">
              <input
                type="email"
                class="form-control"
                v-model="email"
                placeholder="E-posta adresiniz"
                aria-label="E-posta adresiniz"
                required
              />
              <span class="input-group-btn">
                <button
                  class="btn btn-primary"
                  @click="saveEmail(this)"
                  type="button"
                >
                  Kayıt Ol
                </button>
              </span>
            </div>
            <br />
            <small
              :class="[
                message.statusCode === 201 ? 'text-success' : 'text-danger',
              ]"
              style="font-size: 14px; font-weight: bold"
              >{{ message.text }}</small
            >
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default btn-block"
              data-dismiss="modal"
            >
              Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <NoThesisProgramResult
    v-if="isNoThesisProgramTypeSelected === true"
    :programs="tezsizPrograms"
    :isNewApplicationOpen="isNewApplicationOpen"
    :announcementUrl="announcementUrl"
  />
  <ResultsProgram
    v-if="isNoThesisProgramTypeSelected === false"
    :programlar="programlar"
    :isNewApplicationOpen="isNewApplicationOpen"
    :selectedProgramTypeId="selectedProgramTypeId"
    :announcementUrl="announcementUrl"
  />
</template>
<script>
import VueSelect from "vue-select";
import ResultsProgram from "@/components/ResultsProgram.vue";
import NoThesisProgramResult from "@/components/NoThesisProgramResult.vue";
import _ from "lodash";

const TR_LOWER_WORDS = ["ve", "ile", "veya", "için"];

function titleCaseTR(text) {
  return text
    .toLocaleLowerCase("tr")
    .split(" ")
    .map((word) => {
      if (!word) return word;
      if (TR_LOWER_WORDS.includes(word)) return word;
      return word
        .split("-")
        .map((part) =>
          part ? part.charAt(0).toLocaleUpperCase("tr") + part.slice(1) : part
        )
        .join("-");
    })
    .join(" ");
}

export default {
  name: "SearchProgram",
  components: { NoThesisProgramResult, VueSelect, ResultsProgram },
  data() {
    return {
      options: [],
      programlar: [],
      yillar: [],
      selectedProgramTypeId: null,
      selectedYearId: null,
      selectedYearAdi: null,
      selectedSemesterId: null,
      selectedProgramId: null,
      email: null,
      message: {
        text: "",
        statusCode: null,
      },
      currentYearItem: null,
      activePeriod: null,
      announcementUrl: "",
      tezsizPrograms: [],
      isNewApplicationOpen: false,
      isNoThesisProgramTypeSelected: false,
    };
  },
  methods: {
    onSearch(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.search(loading, search, this);
      } else {
        this.options = [];
      }
    },
    programChanged(e) {
      this.selectedProgramId = e ? e.id : null;
    },
    programTypeChanged(e) {
      this.selectedProgramTypeId = e ? e.code : null;
      this.isNoThesisProgramTypeSelected = e ? e.code === 5863 : false;
      if (e && e.code === 5372) {
        this.$swal(
          "Uyarı!",
          "Lisans dereceli doktora kontenjanımız bulunmamaktadır.",
          "info"
        );
      }
    },
    yearChanged(e) {
      this.selectedYearId = e.id;
    },
    semesterChanged(e) {
      this.selectedSemesterId = e.code;
    },
    search: _.debounce((loading, search, vm) => {
      fetch(process.env.VUE_APP_API_URL + `/catalog/search?q=${search}`, {
        method: "GET",
      }).then(async (res) => {
        vm.options = await res.json();
        for (let item of vm.options) {
          item.adi = titleCaseTR(item.adi);
        }
        vm.options.sort((a, b) => a["adi"].length - b["adi"].length);
        loading(false);
      });
    }, 500),
    getInfo: (_this) => {
      if (_this.selectedProgramTypeId == null) {
        _this.$swal("Hata!", "Lütfen program türü seçiniz", "warning");
        return;
      } else if (_this.selectedProgramTypeId === 5863) {
        _this.$swal(
          "Uyarı!",
          "Tezsiz programlar aşağıda listelenmiştir.",
          "info"
        );
        return;
      }

      if (_this.selectedProgramId == null) {
        _this.$swal(
          "Hata!",
          "Lütfen mezun olduğunuz programı arayıp listeden seçiniz",
          "warning"
        );
        return;
      }

      if (_this.selectedYearId == null || _this.selectedSemesterId == null) {
        _this.$swal(
          "Bilgi",
          "Şu anda aktif bir lisansüstü alım dönemi bulunmamaktadır.",
          "info"
        );
        return;
      }

      fetch(
        process.env.VUE_APP_API_URL +
          `/catalog/opened-programs/${_this.selectedProgramId}/${_this.selectedProgramTypeId}/${_this.selectedYearId}/${_this.selectedSemesterId}`,
        {
          method: "GET",
        }
      ).then(async (res) => {
        _this.programlar = await res.json();
        if (_this.programlar.length === 0) {
          _this.$swal(
            "Uyarı!",
            "Mezun olduğunuz alan ile başvurabileceğiniz lisansüstü programımız bulunmamaktadır.",
            "info"
          );
        }
      });
    },
    // Aktif alım dönemini backend'den çeker. Duyuru linki, başvuru
    // durumu (açık/kapalı), bridge sorgusu için yıl/dönem ve tezsiz
    // program listesi tek bir kayıttan gelir; admin panelden yönetilir.
    fetchActivePeriod: async (_this) => {
      // Varsayılan: aktif dönem yok (endpoint erişilemezse de bu hâlde kalır).
      _this.isNewApplicationOpen = false;
      _this.selectedYearAdi = null;
      _this.selectedSemesterId = null;
      _this.announcementUrl = "";
      _this.tezsizPrograms = [];
      try {
        const res = await fetch(
          process.env.VUE_APP_API_URL + `/catalog/admission-period/active/`,
          {
            method: "GET",
          }
        );
        if (!res.ok) return;
        const data = await res.json();
        _this.activePeriod = data;
        if (data && data.active) {
          _this.isNewApplicationOpen = data.is_open;
          _this.selectedYearAdi = data.year_name;
          _this.selectedSemesterId = data.semester_code;
          _this.announcementUrl = data.announcement_url || "";
          _this.tezsizPrograms = data.tezsiz_programlar || [];
        }
      } catch (e) {
        // Endpoint yoksa/erişilemezse sessizce "aktif dönem yok" gibi davran.
      }
    },
    getYilIdWithName: (_this) => {
      if (!_this.selectedYearAdi) return;
      fetch(
        process.env.VUE_APP_API_URL + `/catalog/years/${_this.selectedYearAdi}`,
        {
          method: "GET",
        }
      ).then(async (res) => {
        _this.currentYearItem = await res.json();
        _this.selectedYearId = _this.currentYearItem.id;
      });
    },
    saveEmail: (_this) => {
      fetch(process.env.VUE_APP_API_URL + `/newsletter/subscriber/`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: _this.email }),
      }).then(async (res) => {
        const response = await res.json();
        _this.email = null;
        _this.message = {
          text: response["message"],
          statusCode: res.status,
        };
      });
    },
  },
  mounted: async function () {
    await this.fetchActivePeriod(this);
    await this.getYilIdWithName(this);
  },
};
</script>

<style></style>
